import Content from "./content";
import {Anchor, Space} from "antd";
import {useEffect, useState} from "react";
import {getMenu, getTextFromMdPath} from "../viewModel/viewModel";

export default function MainContent({mdInfo}) {

    // 当前选中item
    const [selectItem, setSelectItem] = useState("")
    // 导航栏数据源
    const [treeData, setTreeData] = useState([])

    const [display, setDisplay] = useState("block")

    const [mdText, setMdText] = useState("")

    const treeNavigationStyle = {
        position: "fixed",
        marginTop: 36,
        left: 8,
        height: "calc(100vh - 64px)",
        zIndex: 100,
        display: display
    }

    const treeStyle = {
        position: 'relative',
        overflowY: "scroll",
        width: 264,
        backgroundColor: "white",
        height: "calc(100vh - 64px)",
    }

    const treeContentStyle = {
        position: "relative",
        top: 64,
        left: (display === "block") ? 273 : 187,
        width: "calc(100vw - 273px - 102px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }

    useEffect(()=> {
        setupSideBarMenu()
    }, [mdInfo])

    function setupSideBarMenu() {
        if (mdInfo !== null) {
            getTextFromMdPath(mdInfo.markdown, (text)=> {
                let haveDownload = !(mdInfo.label.indexOf("快应用") !== -1 || mdInfo.label.indexOf("隐私政策") !== -1 || mdInfo.label.indexOf("广告mock数据") !== -1)
                let newTreeData = getMenu(text, haveDownload)
                if (mdInfo.key === "18") {
                    newTreeData = []
                }
                setMdText(text)
                if (newTreeData.length > 0) {
                    setDisplay("block")
                    setSelectItem(newTreeData[0].href)
                } else {
                    setDisplay("none")
                }
                setTreeData(newTreeData)

                document.documentElement.scrollTo(0, 0)
            })
        }
    }

    return (
        <div>
            <div style={treeNavigationStyle}>
                <Space size={0}>
                    <Anchor
                        theme={{
                            token: {
                                lineHeight: 120,
                            },
                        }}
                        offsetTop={64}
                        getCurrentAnchor={() => {
                            return selectItem
                        }}
                        onChange={(e) => {
                            if (e === "#download_key_anchor") {
                                // 跳转下载
                                window.open(mdInfo.download)
                                return
                            }
                            if (e.length > 0 && e !== selectItem) {
                                setSelectItem(e)
                            }
                        }}
                        style={treeStyle}
                        affix={false}
                        items={treeData}
                    />
                    <div style={{width: 1, height: "calc(100vh)", backgroundColor: "rgba(246,246,246,1)"}}></div>
                </Space>

            </div>
            <div style={treeContentStyle}>
                <Content text={mdText}></Content>
            </div>
        </div>
    )

}
